import { createRootRoute, Outlet } from '@tanstack/react-router';

function RootLayout() {
  return <Outlet />;
}

// 最小化内联回退，使未捕获的路由错误或未知路径渲染可读
// 消息而非空白屏幕。样式化 shell 在后续阶段落地。
const fallbackStyle = {
  padding: '48px 24px',
  fontFamily: 'system-ui, sans-serif',
  textAlign: 'center' as const,
};

function NotFound() {
  return (
    <div style={fallbackStyle}>
      <h1 style={{ fontSize: 24, fontWeight: 600 }}>404</h1>
      <p style={{ color: '#6b7280' }}>This page could not be found.</p>
    </div>
  );
}

function RouteError({ error }: { error: Error }) {
  return (
    <div style={fallbackStyle}>
      <h1 style={{ fontSize: 24, fontWeight: 600 }}>Something went wrong</h1>
      <pre style={{ color: '#b91c1c', whiteSpace: 'pre-wrap' }}>{error.message}</pre>
    </div>
  );
}

export const Route = createRootRoute({
  component: RootLayout,
  notFoundComponent: NotFound,
  errorComponent: RouteError,
});
